import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { defaultBagConditionsOptions, getConditionsFilterConfig } from '../filters/condition';

export const statebagsShopConfig = {
  ...getDefaultShopConfig(),
  filters: [...custom.filters, getConditionsFilterConfig({ options: defaultBagConditionsOptions })],
};
